import { Box } from '@mui/material'
import { AutentiqueSignedProposals } from './autentiqueSignedProposals'
import { HandSignedProposals } from './handSignedProposals'
import { AutentiqueResponse } from './useLoadAutentiqueSignedProposals'

type Props = {
  proposalId: string
  onSignedClick?: (item: AutentiqueResponse) => void
  disableConfirmButton?: boolean
}

export const SignedProposals = (props: Props) => {
  const { proposalId, onSignedClick, disableConfirmButton } = props

  return (
    <Box
      sx={{
        maxHeight: 350,
        overflowY: 'scroll'
      }}
    >
      <AutentiqueSignedProposals
        proposalId={proposalId}
        onSignedClick={onSignedClick}
        disableConfirmButton={disableConfirmButton}
      />
      <HandSignedProposals proposalId={proposalId} />
    </Box>
  )
}
